import { render, staticRenderFns } from "./ApparelAddToCartArea.vue?vue&type=template&id=29110463&"
import script from "./ApparelAddToCartArea.vue?vue&type=script&lang=ts&"
export * from "./ApparelAddToCartArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports